// import Lottie from 'lottie-react'

import Icon from '@/Icon';

import styles from '@/legacy/components/feature/loading.module.scss';

type Props = {
	width?: string | number;
	height?: string | number;
};

const LoadingIcon = () => {
	return <Icon className={styles.shape} path="Sticker_64_Logo_Loading" />;
};

const Loading = () => {
	return (
		<div className={styles.loadingArea}>
			<LoadingIcon />
		</div>
	);
};

export default Loading;
